<template>
  <div class="homePage">
    <div class="fiex" :style="{ top: menuTop + 'px' }">
      <Navigation :active="5"></Navigation>
    </div>
    <div class="right">
      <div class="screen-box">
        <div class="input-box">
          <div class="title">{{ $t("common.notice.messageTitle") }}</div>
          <el-input
            v-model="title"
            :placeholder="$t('module.taskRecord.title6')"
          >
          </el-input>
        </div>
        <div class="input-box">
          <div class="title">{{ $t("common.notice.readStatus") }}</div>
          <el-select
            v-model="read"
            :placeholder="$t('module.goldHistory.title10')"
            clearable
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>

        <button class="screen-btn" @click="getMessages(1)">
          <i class="el-icon-refresh-right refresh" v-if="flagpc"></i>
          {{ $t("module.taskRecord.title8") }}
        </button>
      </div>

      <div class="screen-box2">
        <div class="left">
          <el-select
            v-model="read2"
            :placeholder="$t('common.notice.readStatus')"
            clearable
            @change="getMessages2(1)"
          >
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </div>
        <div class="input-box">
          <input v-model="title2" :placeholder="$t('common.notice.messageTitle')" />
          <img
            @click="getMessages2(1)"
            src="@/assets/image/module/search.png"
          />
        </div>
      </div>

      <div class="list-box" ref="scrollContainer" @scroll="handleScroll">
        <div class="list-item" v-for="(item, index) in tableData2" :key="index">
          <div class="line-box">
            <div class="title">{{ $t("common.notice.messageTitle") }}</div>
            <div class="content">{{ item.Title }}</div>
          </div>

          <div class="line-box">
            <div class="title">{{ $t("common.notice.sendTime") }}</div>
            <div class="content">{{ item.SendTime | dateFrom }}</div>
          </div>

          <div class="line-box">
            <div class="title">{{ $t("common.notice.readStatus") }}</div>
            <div class="content color2">
              <div class="participationStatus" v-if="item.IsRead">
                <span style="background-color: #67c23a"></span>
                {{ $t("common.notice.read") }}
              </div>
              <div class="participationStatus" v-else>
                <span style="background-color: #909399"></span>
                {{ $t("common.notice.unread") }}
              </div>
            </div>
          </div>
          <div class="line-box">
            <div class="title"></div>
            <div class="content-box">
              <div
                class="content color3"
                @click="sendMessages(item.ID, item.Content)"
              >
                {{ $t("common.notice.view") }}
              </div>
              <div
                class="content color3 color4"
                @click="deleteMessages2(item.ID, index)"
              >
                {{ $t("common.notice.delete") }}
              </div>
            </div>
          </div>
        </div>

        <div class="flag" v-if="!flag && tableData2.length !== 0">
          {{ $t("common.notice.loadMore") }}
        </div>
        <div class="flag" v-if="flag && tableData2.length !== 0">
          {{ $t("common.notice.noMoreData") }}
        </div>

        <el-empty
          v-if="tableData2.length === 0"
          :description="$t('common.notice.noData')"
        ></el-empty>
      </div>

      <div class="table-box">
        <el-table :data="tableData" height="880" border style="width: 100%">
          <el-table-column prop="date" :label="$t('common.notice.sendTime')" width="180">
            <template slot-scope="scope">
              {{ scope.row.SendTime | dateFrom }}
            </template>
          </el-table-column>
          <el-table-column prop="Title" :label="$t('common.notice.messageTitle')" width="180">
          </el-table-column>
          <el-table-column
            prop="Content"
            :show-overflow-tooltip="true"
            :label="$t('common.notice.messageContent')"
          >
          </el-table-column>
          <el-table-column
            prop="participationStatus"
            :label="$t('common.notice.readStatus')"
            width="150"
          >
            <template slot-scope="scope">
              <div class="participationStatus" v-if="scope.row.IsRead">
                <span style="background-color: #67c23a"></span>
                {{ $t("common.notice.read") }}
              </div>
              <div class="participationStatus" v-else>
                <span style="background-color: #909399"></span>
                {{ $t("common.notice.unread") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="Auditing" :label="$t('common.notice.operation')" width="100">
            <template slot-scope="scope">
              <span
                class="color5"
                @click="sendMessages(scope.row.ID, scope.row.Content)"
              >
                {{ $t("common.notice.view") }}</span
              >

              <span class="color5" @click="deleteMessages(scope.row.ID)">
                {{ $t("common.notice.delete") }}</span
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-box">
          <el-pagination
            @size-change="getMessages(1)"
            @current-change="getMessages"
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size.sync="size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </div>

    <el-dialog
      :title="$t('common.notice.messageDetail')"
      :visible.sync="contentDialogVisible"
      :before-close="handleClose"
    >
      <div class="dialog-herder">
        <div v-html="content"></div>
      </div>

      <div class="dialog-footer">
        <div class="cancel" @click="handleClose">{{ $t("common.notice.close") }}</div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Navigation from "@/components/Navigation/side";
import { getMessages, sendMessages, deleteMessages } from "@/api/user";
export default {
  filters: {
    dateFrom(data) {
      const date = new Date(data);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份是从0开始的
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      return `${year}-${month}-${day} ${hours}:${minutes}`;
    },
  },
  data() {
    return {
      value1: null,
      value2: null,
      value3: null,
      menuTop: 86,
      options: [
        {
          value: true,
          label: "已读",
        },
        {
          value: false,
          label: "未读",
        },
      ],
      options2: [
        {
          value: 1,
          label: "已审核",
        },
        {
          value: 2,
          label: "待审核",
        },
        {
          value: 3,
          label: "其它",
        },
      ],
      tableData: [],
      tableData2: [],
      currentPage: 1,

      page: 1,
      size: 10,
      total: 0,
      year: null,

      page2: 1,
      size2: 10,
      year2: null,
      title2: null,

      flag: false,
      number: null,
      title: null,
      read2: null,
      read: null,

      contentDialogVisible: false,
      content: null,
      flagpc: false,
    };
  },
  components: { Navigation },
  methods: {
    handleClose() {
      this.contentDialogVisible = false;
    },
    listenScroll() {
      console.log(
        "1111",
        document.body.offsetHeight - document.scrollingElement.scrollTop,
        window.innerHeight
      );
      if (
        document.body.offsetHeight - document.scrollingElement.scrollTop <=
        845
      ) {
        this.menuTop =
          document.body.offsetHeight -
          document.scrollingElement.scrollTop -
          815; //，添加el-menu-item,增加730的数值,减少707相同数值
      } else {
        this.menuTop = 86;
      }
    },

    getMessages(type) {
      if (this.flagpc) {
        return;
      }
      if (type) {
        this.page = type;
      }
      this.flagpc = true;
      getMessages({
        page: this.page,
        size: this.size,
        title: this.title,
        read: this.read,
      })
        .then((res) => {
          this.flagpc = false;
          if (res.code === 200) {
            this.tableData = res.data.list;
            this.total = res.data.dataCount;
          }
        })
        .catch(() => {
          this.flagpc = false;
        });
    },

    getMessages2(type) {
      if (type) {
        this.page2 = type;
        this.flag = false;
        this.tableData2 = [];
      }

      if (this.flag) {
        return;
      }
      getMessages({
        page: this.page2,
        size: this.size2,
        read: this.read2,
        title: this.title2,
      }).then((res) => {
        if (res.code === 200) {
          if (res.data.list.length > 0) {
            this.tableData2 = this.tableData2.concat(res.data.list);
            if (res.data.list.length === 10) {
              this.page2++;
            } else {
              this.flag = true;
            }
          }
        }
      });
    },

    async sendMessages(id, content) {
      this.contentDialogVisible = true;
      this.content = content;
      sendMessages({ id }).then((res) => {
        if (res.code === 200) {
          this.getMessages();
        }
      });
    },

    handleScroll(e) {
      const container = this.$refs.scrollContainer;
      // 检查是否接近底部
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight
      ) {
        // 触底逻辑，例如加载更多数据
        console.log("触底");
        this.getMessages2();
      }
    },

    deleteMessages(ID) {
      this.$confirm("确认删除？删除后数据不可恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const keys = [];
        keys.push(ID);
        deleteMessages({
          keys,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.getMessages();
            this.tableData2 = [];
            this.page2 = 1;
            this.getMessages2();
          }
        });
      });
    },
    deleteMessages2(ID, index) {
      this.$confirm("确认删除？删除后数据不可恢复", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const keys = [];
        keys.push(ID);
        deleteMessages({
          keys,
        }).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.tableData2.splice(index, 1);
            this.tableData = [];
            this.page = 1;
            this.getMessages();
          }
        });
      });
    },
  },
  created() {
    if (this.$route.query.title) {
      this.title = this.$route.query.title;
      this.title2 = this.$route.query.title;
    }
    window.addEventListener("scroll", this.listenScroll);
    this.getMessages();
    this.getMessages2();
  },
  mounted() {},
  destroyed() {
    window.removeEventListener("scroll", this.listenScroll);
  },
};
</script>

<style lang="scss" scoped>
.homePage {
  min-height: 500px;
  display: flex;
  justify-content: flex-end;
  .fiex {
    position: fixed;
    left: 140px;
    transition: top ease 0.1s;
  }
  .right {
    flex-shrink: 0;
    width: calc(100% - 480px);
    margin-right: 140px;
    padding-top: 16px;
  }
}
.dialog-herder {
  width: 100%;
  box-sizing: border-box;
  padding: 0 20px 0 20px;
  color: #474f66;
  font-size: 14px;
  margin-top: 20px;
}
.dialog-footer {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 20px 20px 20px;
  display: flex;
  justify-content: flex-end;

  .cancel {
    padding: 0 24px;
    height: 32px;
    line-height: 32px;
    background: #f8f8f8;
    border: 1px solid #eee;
    border-radius: 4px 4px 4px 4px;
    cursor: pointer;
  }
  .submit {
    padding: 0 24px;
    height: 32px;
    line-height: 32px;
    background: #8948ff;
    border: 1px solid #8948ff;
    border-radius: 4px 4px 4px 4px;
    color: #fff;
    margin-left: 21px;
    cursor: pointer;
  }
}
.color5 {
  font-size: 14px;
  color: #8846ff;
  cursor: pointer;
  margin-right: 5px;
}
//筛选
.screen-box {
  display: flex;
  padding: 20px 0 0 25px;
  background-color: #fff;
  flex-wrap: wrap;
  .input-box {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    margin-right: 25px;
    .title {
      color: #333333;
      font-size: 14px;
      font-weight: bolder;
      margin-right: 15px;
      flex-shrink: 0;
    }
    .el-select {
      width: 150px;
    }
    .el-input {
      width: 150px;
    }
  }
  .screen-btn {
    cursor: pointer;
    margin-right: 25px;
    margin-bottom: 20px;
    border: none;
    color: #fff;
    padding: 0;
    width: 76px;
    height: 32px;
    background: linear-gradient(141deg, #a896ff 0%, #8b4eff 100%);
    box-shadow: 0px 3px 15px 1px rgba(137, 72, 255, 0.4);
    border-radius: 16px 16px 16px 16px;
  }
}
//表格
.table-box {
  margin-top: 16px;
  height: 960px;
  margin-bottom: 24px;
  background-color: #fff;
  .pagination-box {
    display: flex;
    justify-content: flex-end;
    margin-top: 10px;
    margin-right: 25px;
  }
}
.participationStatus {
  color: #474f66;
  display: flex;
  align-items: center;
  justify-content: center;
  span {
    width: 7px;
    height: 7px;
    border-radius: 3.5px;
    margin-right: 10px;
  }
}
.Auditing {
  color: #8948ff;
}

//筛选移动端
.screen-box2 {
  display: none;
  justify-content: space-between;
  align-items: center;
  .left {
    display: flex;
    .el-date-editor {
      width: 130px;
      margin-right: 10px;
    }
  }
  .input-box {
    position: relative;
    input {
      width: 150px;
      height: 40px;
      background: #ffffff;
      border-radius: 20px 20px 20px 20px;
      padding: 0;
      border: none;
      padding: 0 42px 0 12px;
      outline: none;
      box-sizing: border-box;
    }
    img {
      position: absolute;
      right: 12px;
      width: 20px;
      height: 20px;
      top: 8px;
    }
  }
}

//列表移动端
.list-box {
  display: none;
  max-height: 500px;
  overflow: auto;
  margin-top: 15px;
  margin-bottom: 25px;
  .list-item {
    width: 100%;
    background: #ffffff;
    border-radius: 4px 4px 4px 4px;
    margin-bottom: 10px;
    padding: 17px 0;
    .line-box {
      padding: 0 15px 0 10px;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #232323;
      margin-bottom: 12px;
      .title {
        font-size: 14px;
        color: #232323;
      }
      .color1 {
        font-size: 18px;
        color: #8846ff;
        font-weight: bolder;
      }
      .color2 {
        display: flex;
        align-items: center;
        font-size: 14px;
        color: #474f66;
        span {
          width: 7px;
          height: 7px;
          background: #ff6026;
          border-radius: 3.5px;
          margin-right: 10px;
        }
      }
      .content-box {
        display: flex;
      }
      .color3 {
        font-size: 14px;
        color: #8846ff;
      }
      .color4 {
        margin-left: 5px;
      }
    }
  }
  .flag {
    text-align: center;
    color: #999;
    font-size: 14px;
  }
}
</style>
<style scoped>
.table-box >>> .el-table__header .el-table__cell {
  background-color: #fafbfc;
  color: #474f66;
  font-size: 14px;
  font-weight: bolder;
  text-align: center;
}
.table-box >>> .el-table__body .el-table__cell {
  text-align: center;
  color: #474f66;
  font-size: 14px;
}
</style>
<style lang="scss" scoped>
/* 媒体查询 */
@media only screen and (max-width: 1400px) {
  .homePage {
    .fiex {
      left: 70px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 340px);
      margin-right: 70px;
    }
  }
}

@media only screen and (max-width: 1300px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
    }
  }
}

@media only screen and (max-width: 1200px) {
  .homePage {
    .fiex {
      left: 30px;
    }
    .right {
      flex-shrink: 0;
      width: calc(100% - 260px);
      margin-right: 30px;
      .sign-box {
        flex-direction: column;
        .sign {
          width: 100%;
        }
      }
    }
  }
}

@media only screen and (max-width: 1000px) {
  .homePage {
    .fiex {
      display: none;
    }
    .right {
      width: calc(100% - 30px);
      margin-right: 15px;
    }
  }
}

@media only screen and (max-width: 750px) {
  .homePage {
    .screen-box {
      display: none;
    }
    .table-box {
      display: none;
    }
    //筛选移动端
    .screen-box2 {
      display: flex;
    }
    .list-box {
      display: block;
    }
  }
}
</style><style scoped>
.refresh {
  -webkit-animation: rotate 1s linear infinite;
  -moz-animation: rotate 1s linear infinite;
  -o-animation: rotate 1s linear infinite;
  animation: rotate 1s linear infinite;
}
@-webkit-keyframes rotate {
  from {
    -webkit-transform: rotate(0deg);
  }
  to {
    -webkit-transform: rotate(360deg);
  }
}
@-moz-keyframes rotate {
  from {
    -moz-transform: rotate(0deg);
  }
  to {
    -moz-transform: rotate(359deg);
  }
}
@-o-keyframes rotate {
  from {
    -o-transform: rotate(0deg);
  }
  to {
    -o-transform: rotate(359deg);
  }
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(359deg);
  }
}
</style>